/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        17/01/2022 16:34
 * @copyright   Copyright (c) 2002-2022 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class UtilsComponent {
    constructor() {
        UtilsComponent.smooth_scroll()
    }

    static smooth_scroll() {
        const trigger = '[data-trigger="wpiris-scroll"]'

        $(document).on('click', trigger, (e) => {
            e.preventDefault()

            $('html, body').animate(
                {
                    scrollTop: 0,
                },
                {
                    duration: 1000,
                },
            )
        })
    }

    static breakpoint(bp) {
        switch (bp) {
            case 'xsmall':
                return window.matchMedia('(max-width: 370px)').matches
            case 'small':
                return window.matchMedia('(max-width: 650px)').matches
            case 'medium':
                return window.matchMedia('(max-width: 1000px)').matches
            case 'desktop':
                return window.matchMedia('(min-width: 1001px)').matches
        }
    }
}
